// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"22898": "c617a8eb","75229": "d2af4a2e","91447": "cef096c9",}[chunkId] + ".css"
}